/* eslint-disable react/no-multi-comp, react/prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import { Table } from 'components/content-containers/tables/tables';


export function MetadataTable({ items, className, children, header }) {
  return (
    <Table className={classNames(className, 'metadata-table')}>
      { header ||
        <thead>
          <tr className="invisible-row">
            <th className="collapse-width"></th>
            <th></th>
          </tr>
        </thead>
      }
      <tbody>
        { items && _.map(items, (item, index) =>
          <MetadataItem key={index} label={item.label} className={item.classNames}>
            {item.data}
          </MetadataItem>
        )}
        { !items && children }
      </tbody>
    </Table>
  );
}

MetadataTable.propTypes = {
  items: PropTypes.array,
  className: PropTypes.string,
  children: PropTypes.node
};


export function MetadataItem({ label, className, children }) {
  return (
    <tr>
      <td className={classNames('data-label', 'nowrap', className)}>
        {label}
      </td>
      <td className={classNames('data-value', 'align-middle', className)}>
        {children}
      </td>
    </tr>
  );
}
